import $ from 'jquery';
import { Utility } from 'App/track/analytics/util';
import { Universal } from 'App/track/analytics/universal';
import { publish, unpublish, subscribe } from 'Util/pubsub';

var $player;

var selectors = {
	player: '.js-video-player',
	video: '.js-video'
};

var Video = {
	init: function () {
		Video = this;

		Video._initElements();
		Video._initEvents();
	},

	_initElements: function () {
		$player = $(selectors.player);
	},

	_initEvents: function () {
		$player.on('click', selectors.video, Video._processClick);
	},

	_processClick: function () {

		var data = {
			eventCategory: 'Video',
			eventAction: 'Click',
			eventLabel: '',
			eventValue: '1'
		};

		Utility.publishEvent(data);
	}
};

export { Video };